export const CANCEL_ORDER = 'CANCEL_ORDER'; 
export const CREATE_ORDER = 'CREATE_ORDER'; 
export const DETAIL_ORDER = 'DETAIL_ORDER';
export const MY_ORDER = 'MY_ORDER';
export const GET_TRANSACTION_DETAIL = 'GET_TRANSACTION_DETAIL';
export const CHECKOUT_ORDER = 'CHECKOUT_ORDER';